<template>
    <v-layout>
        <v-flex v-if="! overlay">
            <v-row>
                <v-col cols="6">
                    <v-select
                        :items="classes.data"
                        dense
                        item-text="fullName"
                        item-value="IDArtSchule"
                        outlined
                        @change="select">
                    </v-select>
                </v-col>
            </v-row>
            <v-row v-if="classModel.exists()">
                <v-col cols="6">
                    <v-list flat rounded>
                        <v-subheader>mögliche Fächer</v-subheader>
                        <v-list-item-group
                            color="primary">
                            <v-list-item
                                v-for="subject in classModel.availableSubjects"
                                :key="'1_' + subject.IDFaecher"
                                dense
                                @click.once="attach(classModel.IDArtSchule, subject.IDFaecher)">
                                <v-list-item-icon>
                                    <v-icon color="primary" size="14">mdi-plus</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="`${subject.FachName} (${subject.fachkuerzel})`"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-col>
                <v-col cols="6">
                    <v-list flat rounded>
                        <v-subheader>Fächer der Klasse</v-subheader>
                        <v-list-item-group
                            color="red">
                            <v-list-item
                                v-for="subject in classModel.subjects"
                                :key="'2_' + subject.IDFaecher"
                                dense
                                @click.once="detach(classModel.IDArtSchule, subject.IDFaecher)">
                                <v-list-item-icon>
                                    <v-icon color="red" size="14">mdi-minus</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="`${subject.FachName} (${subject.fachkuerzel})`"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-col>
            </v-row>
        </v-flex>
        <overlay v-model="overlay"></overlay>
    </v-layout>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, toRefs} from '@vue/composition-api'
import {useStore} from '../../store'
import {ClassCollection} from '../../store/modules/class-collection'
import {Class} from '../../core/models/class'

export default defineComponent({
    name: 'PageClassSubjectAssignment',

    /**
     * Component constructor.
     * @param props
     * @param context
     */
    setup(props, context) {
        const state = reactive({
            overlay: true
        })

        const store = useStore()

        const classes = computed(() => <ClassCollection>store.getters['classCollection/get'])

        const classModel = computed(() => <Class>store.getters['classModule/get'])

        const select = (id: number) => {
            store.dispatch('classModule/get', {id: id})
        }

        const attach = (id: number, subjectId: number) => {
            store.dispatch('classModule/attachSubject', {id: id, subjectId: subjectId}).then(() => {
                select(id)
            })
        }

        const detach = (id: number, subjectId: number) => {
            store.dispatch('classModule/detachSubject', {id: id, subjectId: subjectId}).then(() => {
                select(id)
            })
        }

        const fetch = () => {
            store.dispatch('classCollection/get').then(() => {
                state.overlay = false
            })
        }

        onMounted(() => {
            fetch()
            store.dispatch('subjectCollection/get')
        })

        return {
            classModel: <Class>classModel.value,
            classes: <ClassCollection>classes.value,
            select,
            attach,
            detach,
            ...toRefs(state)
        }
    }
})
</script>
